<template>
  <div class="page-bg page">
    <SubHeader :title="headerTitle" :isBack="true" :isBg="false"></SubHeader>
    <div class="main">
      <div class="page-content">
        <div class="details-icon">
          <img
            :src="
              info.status == '0'
                ? statusWaitIcon
                : info.status == '1'
                ? statusSuccessIcon
                : statusFailIcon
            "
            alt=""
          />
        </div>
        <div class="details-goods">
          <div
            class="preview-img"
            :style="{ backgroundImage: 'url(' + info.img + ')' }"
          ></div>
          <div class="item-info">
            <div class="title">繁花相送</div>
            <div class="author">冷峻</div>
          </div>
        </div>
        <div class="details-info">
          <div class="item">
            <span class="title">订单金额</span>
            <span class="text">12元</span>
          </div>
          <div class="item">
            <span class="title">交易数量</span>
            <span class="text">1</span>
          </div>
          <div class="item">
            <span class="title">创建时间</span>
            <span class="text">2022-11-15 12:00:32</span>
          </div>
          <div class="item">
            <span class="title">付款时间</span>
            <span class="text">2022-11-15 12:00:32</span>
          </div>
          <div class="item">
            <span class="title">订单编号</span>
            <span class="text">202211150147953834004</span>
          </div>
          <div class="item">
            <span class="title">支付方式</span>
            <span class="text">支付宝</span>
          </div>
          <div class="item">
            <span class="title">支付流水号</span>
            <span class="text">2022111501479538340043834004</span>
          </div>
        </div>
        <div class="details-btn">
          <div class="btn">取消支付</div>
          <div class="btn yellow">继续支付</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import SubHeader from "../../../components/sub_header";

export default {
  name: "order-list",
  data() {
    return {
      headerTitle: "订单详情",
      info: {
        status: 0,
        img: require("../../../assets/images/home/goods/pic.png"),
      },

      statusWaitIcon: require("../../../assets/images/user/order/wait.png"),
      statusSuccessIcon: require("../../../assets/images/user/order/success.png"),
      statusFailIcon: require("../../../assets/images/user/order/fail.png"),
    };
  },
  components: {
    SubHeader,
  },
  mounted() {},

  methods: {},
};
</script>

<style lang="scss" scoped>
.page {
  width: 100%;
  background-size: cover;
  // padding-bottom: 1.2rem;
  box-sizing: border-box;
  height: 100vh;
}
.main {
  overflow: hidden;
  box-sizing: border-box;
  height: calc(100vh - 1.45rem);
  position: relative;
}
.page-content {
  position: relative;
  height: 100%;
  box-sizing: border-box;
  padding: 0 0.4rem 2rem;
  overflow-y: auto;
}
.details-icon {
  text-align: center;
  margin-top: 0.43rem;
  img {
    width: 1.11rem;
    height: 1.11rem;
  }
}

.details-goods {
  margin-top: 0.9rem;
  overflow: hidden;
  background-image: linear-gradient(left, #cfcecb, #afaca8);
  border-radius: 0.15rem;
  overflow: hidden;
  display: flex;
  // align-items: center;
  .preview-img {
    width: 2.4rem;
    height: 2.4rem;
    background-size: cover;
    background-repeat: no-repeat;
    background-position: center;
    border-radius: 0.15rem;
    border: 0.02rem solid #fff;
  }
  .item-info {
    flex: 1;
    padding: 0.4rem;
    color: #404040;
    line-height: 1.6;
    .title {
      font-size: 0.3rem;
    }
    .author {
      font-size: 0.25rem;
      color: #505050;
      margin: 0.3rem 0 0;
    }
  }
}

.details-info {
  padding: 0.4rem;

  .item {
    overflow: hidden;
    font-size: 0.26rem;
    color: #505050;
    line-height: 1.6;
    margin: 0.2rem 0;
    .title {
      float: left;
    }
    .text {
      float: right;
    }
  }
}

.details-btn {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 0.25rem;
  margin-top: 0.6rem;
  .btn {
    font-size: 0.3rem;
    width: 2.42rem;
    height: 0.63rem;
    text-align: center;
    border-radius: 0.63rem;
    background-image: linear-gradient(left, #b7b7b7, #7b7b7b);
    line-height: 0.63rem;

    &.yellow {
      background-image: linear-gradient(left, #f7c378, #d88f20);
    }
  }
}
</style>
